export default __webpack_public_path__ + "static/media/Image3.794fc05c.jpg";